import { useEffect, useState } from "react";

/*
 * Dark-mode signal for the in-app gift card checkout screens only — the website
 * itself has no dark theme. Prefers window.apAppIsDarkMode (the app's resolved
 * theme mode, injected into the webview) and falls back to prefers-color-scheme
 * on app builds that don't inject the global yet.
 */
export const useInAppDarkMode = (): boolean => {
    const [isDark, setIsDark] = useState(false);

    useEffect(() => {
        if (typeof window.apAppIsDarkMode === "boolean") {
            setIsDark(window.apAppIsDarkMode);
            return;
        }
        setIsDark(window.matchMedia?.("(prefers-color-scheme: dark)").matches ?? false);
    }, []);

    return isDark;
};
